import { render, staticRenderFns } from "./ConfigurationView.vue?vue&type=template&id=e99b1920&scoped=true&"
import script from "./ConfigurationView.vue?vue&type=script&lang=js&"
export * from "./ConfigurationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99b1920",
  null
  
)

export default component.exports